export default {
  baseStyle: {
    fontWeight: 'normal',
    _focus: {
      boxShadow: 'none',
    },
  },
  variants: {
    beigeSolid: {
      background: 'beige.50',
      _focus: {
        background: 'beige.50',
      },
      _hover: {
        background: 'beige.50',
      },
    },
    greySolid: {
      background: 'grey.50',
      _focus: {
        background: 'grey.50',
      },
      _hover: {
        background: 'grey.50',
      },
    },
    white: {
      background: 'white',
      _focus: {
        background: 'white',
      },
      _hover: {
        background: 'white',
      },
    },
    orangeSolid: {
      color: 'black',
      background: 'orange.500',
      _focus: {
        background: 'orange.500',
      },
      _hover: {
        background: 'orange.500',
        _disabled: {
          background: 'orange.500',
        },
      },
      _active: {
        background: 'orange.500',
      },
      _disabled: {
        background: 'orange.500',
      },
    },
    blackSolid: {
      color: 'white',
      background: 'black',
      _focus: {
        background: 'black',
        boxShadow: 'none',
      },
      _hover: {
        background: 'white.500',
        _disabled: {
          background: 'orange.500',
        },
      },
      _active: {
        background: 'black',
      },
      _disabled: {
        background: 'black',
      },
    },
    redSolid: {
      color: 'black',
      background: 'red.300',
      _focus: {
        background: 'red.300',
      },
      _hover: {
        background: 'red.300',
        _disabled: {
          background: 'red.300',
        },
      },
      _active: {
        background: 'red.300',
      },
      _disabled: {
        background: 'red.300',
      },
    },
    outlineNegative: {
      color: 'white',
      background: 'none',
      border: '1px',
      borderColor: 'white',
      _hover: {
        background: 'none',
      },
    },
    outline: {
      color: 'grey.200',
      background: 'none',
      border: '1px',
      borderColor: 'grey.200',
      _hover: {
        background: 'none',
      },
    },
    transparent: {
      background: 'none',
      padding: 0,
      _hover: {
        background: 'none',
      },
      sizes: {
        sm: {
          fontSize: 14,
        },
      },
    },
    menuItemButton: {
      justifyContent: 'flex-start',
      variant: 'ghost',
      font: 'Rubik',
      width: '283px',
      height: '39px',
      fontSize: 16,
      fontWeight: 'normal',
      mt: 4,
      bg: 'beige.50',
      _focus: {
        boxShadow: 'none',
        backgroundColor: 'none',
      },
      borderRadius: '8px',
      _hover: {
        backgroundColor: 'none',
      },
      _active: {
        backgroundColor: 'none',
      },
    },
    iconButton: {
      height: '14px',
      width: '14px',
    },
    incrementDecrementButton: {
      p: 0,
      m: 0,
      height: '20px',
      width: '20px',
      minW: '20px',
      borderColor: 'grey.900',
      borderWidth: '1px',
      borderRadius: 'full',
      _focus: {
        boxShadow: 'none',
        backgroundColor: 'none',
      },
      _hover: {
        backgroundColor: 'none',
      },
      _active: {
        backgroundColor: 'none',
      },
    },
  },
};
